/** Uppercase the first ASCII letter of each English word. Lao and other scripts stay as typed. */
export function capitalizeEnglishNameWords(value: string): string {
  return value.replace(
    /(^|[\s-])([a-z])/g,
    (_match, boundary: string, letter: string) =>
      boundary + letter.toUpperCase(),
  );
}
